import React, { useCallback, useState } from 'react'
import {
    Card,
    ContainedButton,
    CardBody,
    CardFooter,
    CardHeader,
    CardTitle,
    GridContainer,
    GridItem,
    Slider,
    Icons,
    Table,
    Typography,
    FbTabs,
    FbTab,
} from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { useHistory } from 'react-router-dom'
import ChartistGraph from 'react-chartist'
import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import axios from 'axios'
import Swal from 'sweetalert2'
import { makeStyles } from '@material-ui/core/styles'
import getEnvVars from '../environment/environment'
import MaterialTable from './Materials/MaterialTable'
import StorageEntryTable from './StorageEntries/StorageEntryTable'
import { BoxTypeOptimization } from './Optimization/BoxTypeOptimization/BoxTypeOptimization'
import { StorageLocationOptimization } from './Optimization/StorageLocationOptimization/StorageLocationOptimization'
import { NeededBoxesCalculation } from "./Optimization/NeededBoxTypeCalculation/NeededBoxesCalculation";

interface OptimizationPageProps {}

export const Optimization: React.FC = (props: OptimizationPageProps) => {
    const [activeTab, setTab] = useState(0)
    const [keycloak] = useKeycloak()
    const history = useHistory()

    const getColor = (props: any) => {
        if (props.isDragAccept) {
            return '#00e676'
        }
        if (props.isDragReject) {
            return '#ff1744'
        }
        if (props.isDragActive) {
            return '#2196f3'
        }
        return '#eeeeee'
    }

    const Container = styled.div`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-width: 2px;
        border-radius: 2px;
        border-color: ${props => getColor(props)};
        border-style: dashed;
        background-color: #fafafa;
        color: #bdbdbd;
        outline: none;
        transition: border 0.24s ease-in-out;
        margin-bottom: 20px;
    `

    function StyledDropzone(props: any) {
        const { acceptedFiles, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            onDrop: files => handleOnDrop(files),
        })

        function handleOnDrop(acceptedFiles: any) {
            const uploaders = acceptedFiles.map((file: any) => {
                const formData = new FormData()
                formData.append('file', file)

                return axios
                    .post(getEnvVars.calcService.uploads.storage_structure, formData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            Authorization: keycloak.token ? `Bearer ${keycloak.token}` : '',
                        },
                    })
                    .then((response: any) => {
                        const { data } = response
                        Swal.fire({
                            title: 'SUCCESS',
                            text: 'Data is being sucessfully uploaded and processed now.',
                            icon: 'success',
                            confirmButtonText: 'Ok',
                        })
                    })
            })

            axios.all(uploaders).then(() => {
                //
            })
        }

        return (
            <div className="container">
                <Container {...getRootProps({ className: 'dropzone', isDragActive, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Drag 'n' drop some files here, or click to select files</p>
                </Container>
            </div>
        )
    }

    const renderTab = () => {
        if (activeTab === 0) {
            return <NeededBoxesCalculation initLoadingTime={2500} />
        }
        if (activeTab === 1) {
            return <BoxTypeOptimization initLoadingTime={2500} />
        }
        if (activeTab === 2) {
            return <StorageLocationOptimization  initLoadingTime={2500} />
        }
    }

    const useStyles = makeStyles(theme => ({
        root: {
            //backgroundColor: theme.palette.secondary.dark,
        },
        indicator: {
            backgroundColor: theme.palette.secondary.contrastText,
        },
    }))

    const useStyles2 = makeStyles(theme => ({
        root: {
            //backgroundColor: theme.palette.secondary.dark,
        }
    }))

    const classes = useStyles()
    const classes2 = useStyles2()

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="plain">
                        <FbTabs
                            classes={classes}
                            centered
                            activeTabIndex={activeTab}
                            didChangeTab={index => setTab(index)}
                        >
                            <FbTab classes={classes2} label="Needed Boxes" value={0} />
                            <FbTab classes={classes2} label="Box Types" value={1} />
                            <FbTab classes={classes2} label="Storage Locations" value={2} />
                          {/*  <FbTab classes={classes2} label="Upload" value={2} />*/}
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center">{renderTab()}</CardBody>
                </Card>
            </GridItem>

            {/* <GridItem xs={12} sm={6} md={6}>
                <BoxTypeOptimization initLoadingTime={2500} />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <StorageLocationOptimization initLoadingTime={1500} />
            </GridItem> */}
        </GridContainer>
    )
}
